import { AxiosResponse } from 'axios';
import VersionedResource from '../VersionedResource';
import { LoanDetectionSettings } from './loanaccounts/LoanDetectionSettings';
import { LoanAccountSettings } from './loanaccounts/LoanAccountSettings';

export class LoanAccountSettingsResource extends VersionedResource {
  public async getLoanSettings(fiId: string): Promise<LoanAccountSettings> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/config/${fiId}/loan-account-settings`);
    return response.data.data;
  }

  public async saveLoanDetectionSettings(fiId: string, settings: LoanDetectionSettings): Promise<LoanDetectionSettings> {
    const url = `/api/rcx/config/${fiId}/loan-account-settings`;

    const response: AxiosResponse = await this.apiClient.put(url, settings);
    return response.data.data;
  }
}

export default LoanAccountSettingsResource;
